import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {SaveChangesDialogData} from "../../interface/SaveChangesDialogData";
import {DEFAULT_SAVE_CHANGES_DIALOG} from "../../constants/matDialogConstants";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'save-changes-popup',
  templateUrl: './save-changes.component.html',
  styleUrl: './save-changes.component.scss'
})
export class SaveChangesComponent {

  title: string = DEFAULT_SAVE_CHANGES_DIALOG.title;
  description: string = DEFAULT_SAVE_CHANGES_DIALOG.description;
  confirmButtonText: string = DEFAULT_SAVE_CHANGES_DIALOG.confirmButtonText;
  cancelButtonText: string = DEFAULT_SAVE_CHANGES_DIALOG.cancelButtonText;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: SaveChangesDialogData,
    private translate: TranslateService
  ) {
    if (data) {
      this.title = data.title ?? this.title;
      this.description = data.description ?? this.description;
      this.confirmButtonText = data.confirmButtonText ?? this.confirmButtonText;
      this.cancelButtonText = data.cancelButtonText ?? this.cancelButtonText;
    }
  }

  getTranslatedText(key: string): string {
    return this.translate.instant(key);
  }
}
